import { SERP_TABS_FLAG, SerpTabsVariant } from '@/constants/experimentConstants';
import { useConfidenceFlag } from '@/hooks/useConfidenceFlag';
import { toSerpTabsVariant } from './serpTabsFlag';

export function useSerpTabsVariant(): SerpTabsVariant {
  const { flagValue } = useConfidenceFlag(SERP_TABS_FLAG.name, SERP_TABS_FLAG.defaultValue, false);
  return toSerpTabsVariant(flagValue);
}
